export enum ECommissionType {
  accommodation = 'accommodation',
  accommodationWithCleaning = 'accommodation_add_cleaning',
  accommodationWithoutChannel = 'accommodation_sub_channel',
  accommodationWithCleaningWithoutChannel = 'accommodation_add_cleaning_sub_channel',
}
